export default __webpack_public_path__ + "assets/512dd813512ed2e71a1c0ddb084cc805.png";